export const API_BASE_URL = 'https://cleanuri.com/api/v1/shorten'
export const CORS_URL = 'https://corsproxy.io/?'
